import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const DeskBell = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M13 4h-1.714c-.703 0-1.321.363-1.678.911L9.554 5h5.178l-.054-.089a1.999 1.999 0 0 0-1.529-.906L13 4zm3 4H8a5 5 0 0 0-5 5v1h18v-1a5 5 0 0 0-4.783-4.995L16 8zm5 9H3v2h18v-2zM1 20v-1h1v-2a1 1 0 0 1 1-1h8v-1H2v-2a6 6 0 0 1 6-6h3V6H8.286a3 3 0 0 1 3-3H13a3 3 0 0 1 2.995 2.824L16 6h-3v1h3a6 6 0 0 1 6 6v2h-9v1h8a1 1 0 0 1 1 1v2h1v1H1z" />
  </SvgIcon>
);

export default DeskBell;
